import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<img alt={{@course.name}} src={{@course.logoUrl}} ...attributes />",{ moduleName: "codecrafters-frontend/components/course-logo.hbs" })